/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import { assign } from 'xstate';

import { INITIAL_CONTEXT } from './config';

export const actions = {
  successAction: assign((context, event) => ({
    payload: event?.data?.value,
  })),
  failureAction: assign((context, event) => ({
    payload: event?.data?.value,
  })),
  resetAction: assign((context, event) => ({
    payload: null,
    context: INITIAL_CONTEXT,
  })),
};
